export const GET_INVENTORY_FEATURE_FLAG = `GET_INVENTORY_FEATURE_FLAG`;
export const SET_INVENTORY_FEATURE_FLAG = `SET_INVENTORY_FEATURE_FLAG`;
export const HANDLE_ACCESS_BUSINESS_LIBRARY = `HANDLE_ACCESS_BUSINESS_LIBRARY`;
export const HANDLE_ACCESS_BRAND_MENU = `HANDLE_ACCESS_BRAND_MENU`;
